import { brand, shadows } from '@alison/ui';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

interface SettingsCardProps {
  title: string;
  subtitle: string;
  icon?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}

export function SettingsCard({
  title,
  subtitle,
  icon,
  action,
  children,
}: SettingsCardProps): ReactNode {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1.5,
        boxShadow: shadows.card,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          py: 3,
          px: 4,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        {icon ? (
          <Box
            sx={{
              width: 36,
              height: 36,
              flexShrink: 0,
              borderRadius: 1,
              bgcolor: 'info.bg',
              color: brand.purple,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
        ) : null}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontSize: 15, fontWeight: 700, color: 'text.primary' }}>
            {title}
          </Typography>
          <Typography sx={{ fontSize: 12, color: 'text.secondary', mt: 1 }}>{subtitle}</Typography>
        </Box>
        {action}
      </Box>
      <Box sx={{ py: 4, px: 4 }}>{children}</Box>
    </Box>
  );
}
